<template>
  <div>
    <connect-icon />
    <h5 class="text-center">{{ $t("imports.connectGoogleClassroom") }}</h5>
    <p class="text-center">{{ $t("imports.googleLinkDescription") }}</p>
    <eg-b-alert show variant="secondary">
      <div>{{ $t("imports.dontForget") }}</div>
      <ol class="mt-3 pl-4">
        <li>{{ $t("imports.allowSelectAll") }}</li>
        <li>
          {{ $t("imports.weWillNot") }}
          <strong>{{ $t("imports.never") }}</strong>
          {{ $t("imports.noChangesToLms", { lms: "Google Classroom" }) }}
        </li>
        <li>
          {{ $t("imports.googleApiTransfer") }}
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            target="_blank"
          >
            {{ $t("imports.googleApiPolicy") }}</a
          >{{
            $t("imports.googleApiLimitedUse", {
              limitedUse: $t("imports.limitedUse"),
            })
          }}
        </li>
      </ol>
    </eg-b-alert>
  </div>
</template>

<script>
import ConnectIcon from "@/views/dashboard/workspace-integration/icons/connect-icon.vue";

export default {
  components: { ConnectIcon },
};
</script>
